<app-breadcrumb  [master]="'Rozliczenia'" [parentName]="'Archiwum'" [name]="'Prowizje'"></app-breadcrumb>
<div class="commission-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="commission-import-list-filters">

    <app-dict-insurance-companies
      [multiple]="false" label="TU"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
      (selectedInsuranceCompany)="selectedInsuranceCompanies = $event"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="false" label="Importer"
      class="commission-import-list-filter"
      [dictType]="'commission_importer_' +  selectedInsuranceCompanies?.key"
      [(ngModel)]="initialFilters.importer" name="importer"
    ></app-dict>

    <mat-form-field
      class="commission-import-list-filter"
      matTooltip="Dodaj &quot;%&quot; na początku numeru, aby wyszkiwać prowizję, która zawiera daną frazę. Użyj &quot;_&quot; jeśli dotyczy to tylko jednego znaku."
      matTooltipPosition="above"
    >
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="policyNumber" [(ngModel)]="initialFilters.policyNumber">
    </mat-form-field>

    <app-dict
      [multiple]="false" label="Firma"
      class="commission-import-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      [multiple]="false" label="Partner"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>


  </form>

  <div class="commission-import-list-buttons">
    <!--    <button (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report || loadingData"
                mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>-->
    <button *ngIf="(userPermissions | async).settlement.read_report" [disabled]="!(userPermissions | async).settlement.read_report"
            mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button *ngIf="(userPermissions | async).settlement.read_report" [disabled]="!initialFilters.partner && !initialFilters.ofwca"   mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
    </mat-menu>




    <button (click)="filter()"   [disabled]="loadingData" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  [disabled]="loadingData"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.firstName}}  {{element.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        {{element.fullName}}
      </td>
    </ng-container>


    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompanyName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="importer">
      <th mat-header-cell *matHeaderCellDef> Importer </th>
      <td mat-cell *matCellDef="let element">
        {{element.importerName}}
      </td>
    </ng-container>


    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef> Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        {{element.policyNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.companyName}}
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [disabled]="loadingData" [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
